<template>
  <div class="container">
    <div class="userinfo">
      <img :src="wxUser.uIcon"
           alt
           v-if="wxUser.uIcon" />
      <img src="../../assets/images/headericon.png"
           alt
           v-else />
      <p>{{wxUser.uUsername || '登录用户'}}</p>
    </div>
    <div class="user-form">
      <div class="form-item">
        <label for>
          <em>*</em>手机号：
        </label>
        <input type="text"
               placeholder="请输入手机号"
               v-model="phone" />
        <img src="../../assets/images/clean.png"
             alt
             style="width:14px;height:14px"
             @click="cleanPhone" />
      </div>
      <div class="form-item">
        <label for>
          <em>*</em>验证码：
        </label>
        <input type="text"
               placeholder="请输入验证码"
               v-model="identify" />
        <button class="btn"
                @click="getCode">{{buttonTxt}}</button>
      </div>
      <div class="form-item">
        <label for>
          <em>*</em>真实姓名：
        </label>
        <input type="text"
               placeholder="请输入真实姓名"
               v-model="name" />
      </div>
      <div class="form-item">
        <label for>
          <em>*</em>行业：
        </label>
        <input type="text"
               readonly
               placeholder="请选择行业"
               v-model="uIndustry"
               @click="showPicker = true" />
        <img src="../../assets/images/xia.png"
             alt
             srcset
             style="height:8px" />
        <span class="tips">注：行业可多选</span>
      </div>
    </div>
    <button class="big-btn"
            @click="bindMobile">提交</button>
    <div style="margin:10px;text-align:center;font-size:14px">
      <a href="index/live"
         style="color:#1A8BFF">先去逛逛>></a>
    </div>
    <van-popup v-model="showPicker"
               position="bottom"
               :style="{ height: '30%' }">
      <div class="pop-title">
        <van-button type="default"
                    size="mini"
                    @click="showPicker = false">取消</van-button>
        <van-button type="primary"
                    size="mini"
                    @click="setIndustry">确定</van-button>
      </div>
      <ul class="picker-list">
        <li v-for="item in columns"
            :key="item.dictId"
            @click="selectIndustry(item)"
            :class="{checked: dictIds.indexOf(item.dictId) > -1}">{{item.dictName}}</li>
      </ul>
    </van-popup>
  </div>
</template>
<script>
import AppSetting from '../../AppSetting';
import loginService from '../../plugin/extendFn/loginService';
import store from "../../store";

export default {
  data () {
    return {
      wxUser: {},
      phone: "",
      identify: "",
      name: "",
      uIndustry: "",
      buttonTxt: "获取验证码",
      columns: [],
      dictIds: [],
      industrys: [],
      showPicker: false
    };
  },
  async mounted () {
    this.ra_wxUser =await loginService.getLoginUser();
    this.getLevelList();
    document.title = "完善信息";
  },
  methods: {
    bindMobile () {
      let params = {
        phone: this.phone,
        name: this.name,
        identify: this.identify,
        uIndustry: this.uIndustry
      };
      if (this.name == "") {
        this.topTips("请输入姓名！");
        return false;
        
      }
      this.$postHttp(AppSetting.baseUrl + "/student/update", params).then(async res => {
        // console.log(res);
        if (res.data.code == 0) {
          await loginService.setLoginUser(res.data.student)
          this.toast("登录成功！");
          setTimeout(() => {
            window.history.go(-1);
          }, 2000);
        } else if (res.data.code == 2003) {
          this.topTips("验证码错误！");
        } else if (res.data.code == 2001) {
          this.topTips("验证码过期！");
        } else {
          this.topTips("绑定失败！");
        }
      });
    },
    getCode () {
      var reg = 11 && /^((13|14|15|16|17|18)[0-9]{1}\d{8})$/;

      if (this.phone == "") {
        this.topTips("请输入手机号!");
        return;
      } else if (!reg.test(this.phone)) {
        this.topTips("手机格式不正确!");
        return;
      }
      if (this.disable == false) {
        return;
      }
      this.$postHttp(AppSetting.baseUrl + "/login/identify", {
        phone: this.phone,
        type: "student"
      }).then(res => {
        // console.log(res);
        if (res.data.code == 2007) {
          this.topTips("验证码发送失败");
        } else if (res.data.code == 0) {

          let num = 59;
          this.buttonTxt = num + "s后重发";
          this.disable = false;
          let timer = setInterval(() => {
            num--;
            this.buttonTxt = num + "s后重发";
            if (num < 1) {
              this.disable = true;
              // obtn.style.color = '#007EFF';
              this.buttonTxt = "重新获取";
              clearInterval(timer);
            }
          }, 1000);

          // this.toast('验证码发送成功');
        } else if (res.data.code == 2008) {
          this.topTips("此手机号已被绑定!");
        }
      });
    },
    cleanPhone () {
      this.phone = "";
    },
    setIndustry () {
      this.uIndustry = this.industrys.join(",");
      this.showPicker = false;
    },
    selectIndustry (item) {
      let _idx = this.dictIds.findIndex(val => {
        return val == item.dictId;
      });
      if (_idx > -1) {
        this.dictIds.splice(_idx, 1);
        this.industrys.splice(_idx, 1);
      } else {
        this.dictIds.push(item.dictId);
        this.industrys.push(item.dictName);
      }
    },
    getLevelList () {
      this.$postHttp(AppSetting.baseUrl + "/dictionary/app/list", {
        dictType: "INDUSTRY"
      }).then(res => {
        if (res.data.code == 0) {
          let data = res.data.list;
          this.columns = data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  .userinfo {
    background-color: #007eff;
    padding: 17px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 75px;
      height: 75px;
      border-radius: 50%;
    }
    p {
      margin-top: 10px;
      color: #ffffff;
      font-size: 16px;
    }
  }
}
.user-form {
  .form-item {
    position: relative;
    margin: 0 13px;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333333;
    border-bottom: 1px solid #d9e2e9;
    label {
      width: 100px;
      font-size: 14px;
      font-weight: bold;
    }
    em {
      color: red;
      margin-left: -4px;
      font-style: normal;
      margin-right: 5px;
    }
    input {
      margin: 0 10px;
      flex: 1;
      font-size: 14px;
      outline: none;
      border: none;
    }
    .btn {
      width: 100px;
      padding: 5px 10px;
      border: none;
      outline: none;
      background: #05a2ff;
      color: #ffffff;
      border-radius: 14px;
      font-size: 13px;
    }
    .tips {
      color: red;
      position: absolute;
      right: 0;
      bottom: -25px;
      font-size: 12px;
    }
    ::-webkit-input-placeholder {
      color: #b6c2ce;
    }
  }
}
.big-btn {
  margin-top: 50px;
  width: 100%;
  border: none;
  background-color: #05a2ff;
  color: #ffffff;
  line-height: 35px;
  text-align: center;
  font-size: 14px;
}
.picker-list {
  font-size: 14px;
  text-align: center;
  line-height: 35px;
}
.pop-title {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  padding: 5px;
}
.checked {
  color: #007eff;
}
</style>



// WEBPACK FOOTER //
// src/components/me/bindMobile.vue